//hooks/apis.js
const CONTACTUS_API =
  "https://crcbharat.com/apis/ContactSubmissions.php";
const Login_api = "https://crcbharat.com/apis/login.php";
const Signup_api = "https://crcbharat.com/apis/signup.php";

const APPLY_JOB = "https://crcbharat.com/apis/Careers.php";

const Fetch_all_data =
  "https://crcbharat.com/apis/fetch_all_data.php";

const CRUD_Domains = "https://crcbharat.com/apis/CRUD_Domains.php";

const CRUD_Price_table = "https://crcbharat.com/apis/CRUD_Price_table.php";

const get_donations  ="https://crcbharat.com/apis/donations/get_donations.php"
const get_members  ="https://crcbharat.com/apis/donations/get_members.php"
const get_all_members = "https://crcbharat.com/apis/donations/get_all_members.php"
const upcoming_events = "https://crcbharat.com/apis/upcomingevents.php"

export {
  CONTACTUS_API,get_donations,get_members,upcoming_events,
  Login_api,
  Signup_api,
  APPLY_JOB,
  Fetch_all_data,
  CRUD_Domains,
  CRUD_Price_table,
  get_all_members,
};

